import React from "react";
import { Skeleton, Space } from "antd";
import { PageContainer, PageHeader, FiltersContainer } from "./EInvoiceBatches.styled";

export const EInvoiceBatchesLoading: React.FC = () => {
  return (
    <PageContainer>
      <PageHeader>
        <Skeleton.Input active style={{ width: 200, height: 32 }} />
        <Skeleton.Button active style={{ width: 100 }} />
      </PageHeader>

      <FiltersContainer>
        <Space size={16} wrap>
          <div style={{ width: 200 }}>
            <Skeleton.Input active size="small" style={{ width: 80, marginBottom: 4 }} />
            <Skeleton.Input active style={{ width: "100%" }} />
          </div>
        </Space>
      </FiltersContainer>

      <Skeleton active paragraph={{ rows: 10 }} />
    </PageContainer>
  );
};

export const EInvoiceBatchDetailLoading: React.FC = () => {
  return (
    <PageContainer>
      <Skeleton.Button active style={{ width: 120, marginBottom: 16 }} />

      <PageHeader>
        <Skeleton.Input active style={{ width: 250, height: 32 }} />
        <Space>
          <Skeleton.Button active style={{ width: 100 }} />
          <Skeleton.Button active style={{ width: 120 }} />
        </Space>
      </PageHeader>

      <Skeleton active paragraph={{ rows: 4 }} style={{ marginBottom: 24 }} />
      <Skeleton active paragraph={{ rows: 10 }} />
    </PageContainer>
  );
};





